import { Colors } from './types';

export const baseColors = {
  failure: '#800020',
  primary: '#CE022D',
  primaryBright: '#53DEE9',
  primaryDark: '#0098A1',
  secondary: '#7645D9',
  success: '#4040ff',
  warning: '#FFB237',
  textColour: '#ffffff',
};

export const brandColors = {
  binance: '#F0B90B',
};

export const lightColors: Colors = {
  ...baseColors,
  ...brandColors,
  primary: '#CE022D',
  textColour: '#ffffff',
  background: '#FAF9FA',
  backgroundDisabled: '#E9EAEB',
  contrast: '#191326',
  invertedContrast: '#FFFFFF',
  input: '#eeeaf4',
  inputSecondary: '#d7caec',
  tertiary: '#EFF4F5',
  text: '#000000',
  textDisabled: '#BDC2C4',
  textSubtle: '#2D2159',
  borderColor: '#E9EAEB',
  card: '#FFFFFF',
  gradients: {
    bubblegum: 'linear-gradient(139.73deg, #E6FDFF 0%, #F3EFFF 100%)',
  },
};

export const darkColors: Colors = {
  ...baseColors,
  ...brandColors,
  primary: '#ffffff',
  textColour: '#000000',
  secondary: '#9A6AFF',
  background: '#100C18',
  backgroundDisabled: '#3c3742',
  contrast: '#FFFFFF',
  invertedContrast: '#191326',
  input: '#483f5a',
  inputSecondary: '#66578D',
  primaryDark: '#0098A1',
  tertiary: '#353547',
  text: '#ffffff',
  textDisabled: '#666171',
  textSubtle: '#ffffff',
  borderColor: '#524B63',
  card: '#27262c',
  gradients: {
    bubblegum: 'linear-gradient(139.73deg, #313D5C 0%, #3D2A54 100%)',
  },
};
